import { useGetFeatures, useGetFeaturesForTemplate, useGetTemplate, useUpdateTemplate } from '../api/queries'
import { TemplateDetail } from '../TemplateDetail/TemplateDetail'
import type { TemplateFeature } from '../types'

interface TemplateDetailAdapterProps {
  templateId: string
  navigateBack: () => void
}

export const TemplateDetailAdapter = ({ templateId, navigateBack }: TemplateDetailAdapterProps) => {
  const { data: template } = useGetTemplate(templateId)
  const { data: allFeatures, isLoading: featuresIsLoading } = useGetFeatures()
  const { data: templateFeatures, isLoading: templateFeaturesIsLoading } = useGetFeaturesForTemplate(templateId)
  const { mutateAsync: updateTemplate } = useUpdateTemplate(templateId)

  if (!template || featuresIsLoading || templateFeaturesIsLoading) {
    return null
  }

  template.features = templateFeatures || []

  return (
    <TemplateDetail
      template={template}
      allFeatures={allFeatures || []}
      navigateBack={navigateBack}
      onSave={async (localFeatures: TemplateFeature[]) => {
        const result = await updateTemplate(localFeatures)

        return result.status === 200
      }}
    />
  )
}

export default TemplateDetailAdapter
